export function getUnique(arr: any[]): any[] {
    return [...new Set(arr)];
}

/**
 * Given an array of numbers, this function reduces the size of the array by dividing
 * the length of the array by the specified `groupSize` value and calculating the average
 * of adjacent groups of elements. The resulting array contains the average values in
 * the order they were calculated.
 *
 * @param arr The input array to be reduced in size.
 * @param groupSize The number of elements in each group to be averaged.
 * @returns An array containing the average values of adjacent groups of elements.
 */
export function reduceArrayByAveragingAdjacentGroups(arr: number[], groupSize: number): number[] {
    const result: number[] = [];
    for (let i = 0; i < arr.length; i += groupSize) {
        const group = arr.slice(i, i + groupSize);
        const avg = group.reduce((a, b) => a + b) / group.length;
        result.push(avg);
    }
    return result;
}

export function range(size: number, startAt = 0): ReadonlyArray<number> {
    return [...Array(size).keys()].map(i => i + startAt);
}
